import { IState } from '../../../store';
import { IHighwayInfo } from '../../../types/geo/highway';

export function highwaysSelector(state: IState): IHighwayInfo[] | null {
  return state.offerData.offer.geo.highways;
}
